import type { OrgTipo } from './navigation';

/** Org efectivo del tenant (producto hospital: sin preview de rubros clínicos). */
export function effectiveOrgTipo(
  tenantOrg: OrgTipo | null,
  _isHospital: boolean,
): OrgTipo | null {
  return tenantOrg;
}
